export const listProcedures = [
  {
    procedureId: 1013,
    name: 'BSE'
  },
  {
    procedureId: 1018,
    name: 'Constancia de estudios'
  },
  {
    procedureId: 1017,
    name: 'Rectificación de nota'
  },
  {
    procedureId: 1019,
    name: 'Constancia de ingreso'
  },
  {
    name: 'Registro de fotografía',
    procedureId: 1020
  },
  {
    procedureId: 1022,
    name: 'Constancia de pertenencia a tercio, quinto, décimo'
  },
  {
    procedureId: 1023,
    name: 'Constancia de promedio ponderado (periodo)'
  },
  {
    procedureId: 1024,
    name: 'Constancia de promedio ponderado acumulado'
  },
  {
    procedureId: 1025,
    name: 'Constancia de matrícula'
  },
  {
    procedureId: 1021,
    name: 'Retiro de periodo lectivo'
  },
  {
    procedureId: 1027,
    name: 'Constancia de adeudo / no adeudo'
  },
  {
    procedureId: 1032,
    name: 'Certificado de estudios'
  },
  {
    procedureId: 1026,
    name: 'Cambio de carrera, campus o modalidad'
  },
  {
    name: 'Emisión de carné universitario',
    procedureId: 1030
  },
  {
    name: 'Cambio de modalidad',
    procedureId: 1031
  },
  {
    name: 'Reincorporación',
    procedureId: 1033
  },
  { name: 'Examen de rezagados', procedureId: 1034 },
  {
    name: 'Retiro de curso',
    procedureId: 1036
  },
  {
    name: 'Validación de seguro',
    procedureId: 1037
  },
  {
    name: 'Carta de presentación para práctica o empleo',
    procedureId: 1038
  },
  {
    name: 'Constancia de egresado',
    procedureId: 1040
  }
];
